// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".quantity__container[data-v-2ba2f1e3]{padding:10px;border:var(--border-thickness) solid;display:flex;justify-content:space-between;align-items:center}.quantity__container svg[data-v-2ba2f1e3]{height:20px;-webkit-user-select:none;-moz-user-select:none;user-select:none;transition:.4s ease-in-out}.quantity__container svg[data-v-2ba2f1e3]:not(.disabled){cursor:pointer}.quantity__container svg[data-v-2ba2f1e3]:not(.disabled):hover{opacity:var(--hover-opacity)}", ""]);
// Exports
module.exports = exports;
